import { render } from "./plus.vue?vue&type=template&id=4da0cc7f"
import script from "./plus.vue?vue&type=script&lang=js"
export * from "./plus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__